import { render } from "./ActiveMessagesPopup.vue?vue&type=template&id=0f8d08ed&scoped=true&ts=true"
import script from "./ActiveMessagesPopup.vue?vue&type=script&lang=ts"
export * from "./ActiveMessagesPopup.vue?vue&type=script&lang=ts"

import "./ActiveMessagesPopup.vue?vue&type=style&index=0&id=0f8d08ed&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8d08ed"]])

export default __exports__